<template>
  <div>
    <p v-if="!hasAccess" class="grey--text mb-4">
      Configure a credencial Opera360 API fornecida pela Claro para esta empresa.
      Cada empresa pode ter apenas uma credencial.
    </p>

    <v-form ref="validForm">
      <v-text-field
        v-model="form.description"
        label="Descrição"
        outlined
        dense
        prepend-inner-icon="mdi-text-short"
        :rules="[v => !!v || 'O campo é obrigatório']"
      />
      <v-text-field
        v-model="form.client_id"
        label="Client ID"
        outlined
        dense
        prepend-inner-icon="mdi-key"
        :rules="[v => !!v || 'O campo é obrigatório']"
      />
      <v-text-field
        v-model="form.client_secret"
        label="Client Secret"
        outlined
        dense
        prepend-inner-icon="mdi-lock"
        :append-icon="secretShow ? 'mdi-eye' : 'mdi-eye-off'"
        :type="secretShow ? 'text' : 'password'"
        :rules="secretRules"
        @click:append="secretShow = !secretShow"
      />
      <v-text-field
        v-model="form.requesting_user_email"
        label="E-mail solicitante"
        outlined
        dense
        prepend-inner-icon="mdi-email-outline"
        :rules="[
          v => !!v || 'O campo é obrigatório',
          v => /.+@.+\..+/.test(v) || 'E-mail inválido',
        ]"
      />
      <v-switch
        v-if="hasAccess"
        v-model="form.active"
        inset
        :label="form.active ? 'Ativo' : 'Inativo'"
      />
    </v-form>

    <div class="d-flex justify-end mt-4">
      <v-btn color="primary" :loading="saving" @click="save">
        Salvar credencial
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      loading: true,
      saving: false,
      secretShow: false,
      form: {
        description: "",
        client_id: "",
        client_secret: "",
        requesting_user_email: "",
        active: true,
      },
    };
  },
  computed: {
    ...mapState("configurationIntegration", ["opera360Access"]),
    hasAccess() {
      return Boolean(this.opera360Access && this.opera360Access.id);
    },
    secretRules() {
      if (this.hasAccess) {
        return [];
      }

      return [v => !!v || "O campo é obrigatório"];
    },
  },
  async mounted() {
    await this.loadAccess();
  },
  watch: {
    opera360Access() {
      this.fillFormFromAccess();
    },
  },
  methods: {
    ...mapActions("configurationIntegration", [
      "loadOpera360Access",
      "saveOpera360Access",
      "updateOpera360Access",
    ]),
    async loadAccess() {
      this.loading = true;
      try {
        await this.loadOpera360Access();
        this.fillFormFromAccess();
      } catch (error) {
        this.$swal("Oops...", error.message, "error");
      }
      this.loading = false;
    },
    fillFormFromAccess() {
      if (!this.opera360Access) {
        this.form = {
          description: "",
          client_id: "",
          client_secret: "",
          requesting_user_email: "",
          active: true,
        };
        return;
      }

      this.form = {
        description: this.opera360Access.description,
        client_id: this.opera360Access.client_id,
        client_secret: "",
        requesting_user_email: this.opera360Access.requesting_user_email,
        active: Boolean(this.opera360Access.active),
      };
    },
    async save() {
      if (!this.$refs.validForm.validate()) {
        return;
      }

      this.saving = true;
      try {
        if (this.hasAccess) {
          await this.updateOpera360Access({ ...this.form });
          this.$swal("Credencial atualizada com sucesso", "", "success");
        } else {
          await this.saveOpera360Access({ ...this.form });
          this.$swal("Credencial cadastrada com sucesso", "", "success");
        }
        await this.loadAccess();
        this.$emit("access-changed");
      } catch (error) {
        this.$swal("Oops...", error.message, "error");
      }
      this.saving = false;
    },
  },
};
</script>
